module.exports = __webpack_public_path__ + "img/service-resource04.3a160ef6.jpg";